import { createContext } from 'react';
import { DEFAULT_START_STOP_VALUE } from '../../internal/constants';
export default /*#__PURE__*/ createContext(DEFAULT_START_STOP_VALUE);

//# sourceMappingURL=PerformanceMonitorStartStopContext.js.map